module.exports = __webpack_public_path__ + "img/c02_unitpalintonon_Normal_ua.6f489d75.webp";